export default __webpack_public_path__ + "static/media/528hz-deep-meditation.d7b29554.mp3";